<div class="headline">
  <span class="mat-h1 m0">Textsorten</span>

  @if (authService.isLoggedIn() && (authService.getUserRole() === 'ROLE_ADMIN' || authService.getUserRole() === 'ROLE_USER_PAID')) {
    <span class="editing-group">
      @if (authService.getUserRole() === 'ROLE_ADMIN' || authService.getUserRole() === 'ROLE_USER_PAID') {
        <button (click)="toggleSelectMode()" [attr.aria-pressed]="selectMode"
                aria-label="Einträge für Sammelmappen auswählen"
                class="header-buttons" color="primary" mat-flat-button>
          <mat-icon>{{ selectMode ? 'close' : 'create_new_folder' }}</mat-icon>
          <mat-label class="home-new-word-bt-text">{{ selectMode ? 'Auswahl beenden' : 'Sammelmappe' }}</mat-label>
        </button>
      }

      @if (displayEditingTools === true && authService.getUserRole() === 'ROLE_ADMIN') {
        <button (click)="sendExportTextTypesRequest()"
                aria-label="Button to export all text patterns"
                class="header-buttons" color="accent" mat-flat-button>
          <mat-icon class="add-icon">share</mat-icon>
          <mat-label class="home-new-word-bt-text">Vollständiger Export</mat-label>
        </button>
      }

      @if (displayEditingTools === true && authService.getUserRole() === 'ROLE_ADMIN') {
        <button (click)="openNewTextTypeDialog()"
                aria-label="Button to add a new category" class="header-buttons"
                color="primary" mat-flat-button>
        <mat-icon>add</mat-icon>
        <mat-label class="home-new-word-bt-text"> <span class="plain-text-new">Neue</span> Textsorte</mat-label>
      </button>
      }

      @if (displayEditingTools === true && authService.getUserRole() === 'ROLE_ADMIN') {
        <button (click)="toggleEditingTools(true)"
                aria-label="Button to disable editing"
                class="editing-buttons header-buttons" mat-flat-button>
          <mat-icon>remove_red_eye</mat-icon>
          <mat-label class="home-new-word-bt-text">Ansicht</mat-label>
        </button>
      }

      @if (displayEditingTools === false && authService.getUserRole() === 'ROLE_ADMIN') {
        <button (click)="toggleEditingTools(true)"
                aria-label="Button to enable editing"
                class="editing-buttons header-buttons" mat-flat-button>
          <mat-icon>edit</mat-icon>
          <mat-label class="home-new-word-bt-text">Bearbeiten</mat-label>
        </button>
      }

    </span>
  }
</div>

<hr>

<div class="main-content-wrapper">
  <div class="table-content">
    <div class="mat-elevation" style="background-color: white">
      <div class="w100">

        <div class="pad16 flex-horizontal-space-between upper-searchbar-wrapper">
          <mat-form-field appearance="outline" class="search-input-field dense-2 w49" subscriptSizing="dynamic">
            <input matInput placeholder="Suche..." (input)="getParams()" [formControl]="searchControl">
          </mat-form-field>
          <div class="w49 flex-horizontal-space-between">
            <mat-form-field appearance="outline" class="select-input-field dense-2 w49" subscriptSizing="dynamic">
              <mat-label>Fertigkeit</mat-label>
              <mat-select [formControl]="modesFilterModeControl" multiple>
                @for (option of modesFilterModeList; track option) {
                  <mat-option [value]="option" (click)="getParams()"> {{ formOptionsLists.modesToString.get(option) }}</mat-option>
                }
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="select-input-field dense-2 w49" subscriptSizing="dynamic">
              <mat-label>Interaktion</mat-label>
              <mat-select [formControl]="interactionsFilterModeControl" multiple>
                @for (option of interactionsFilterModeList; track option) {
                  <mat-option [value]="option" (click)="getParams()">{{ formOptionsLists.interactionsToString.get(option) }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="pad16 flex-horizontal-space-between lower-searchbar-wrapper">
          <div class="w49 flex-horizontal-space-between">
            <mat-form-field appearance="outline" class="select-input-field dense-2 w49" subscriptSizing="dynamic">
              <mat-label>Medium</mat-label>
              <mat-select [formControl]="mediaFilterModeControl" multiple>
                @for (option of mediaFilterModeList; track option) {
                  <mat-option [value]="option" (click)="getParams()">{{ formOptionsLists.mediaToString.get(option) }}</mat-option>
                }
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="select-input-field dense-2 w49" subscriptSizing="dynamic">
              <mat-label>Zweck</mat-label>
              <mat-select [formControl]="purposeFilterModeControl" multiple>
                @for (option of purposeFilterModeList; track option) {
                  <mat-option [value]="option" (click)="getParams()">{{ formOptionsLists.purposesToString.get(option) }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>

          <div class="w49 flex-horizontal-space-between">

            <mat-form-field appearance="outline" class="select-input-field dense-2 w49" subscriptSizing="dynamic">
              <mat-label>Darstellungsform</mat-label>
              <mat-select [formControl]="representationsFilterModeControl" multiple>
                @for (option of representationsFilterModeList; track option) {
                  <mat-option [value]="option" (click)="getParams()">{{ formOptionsLists.representationsToString.get(option) }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="select-input-field dense-2 w49" subscriptSizing="dynamic">
              <mat-label>Bereich</mat-label>
              <mat-select [formControl]="domainsFilterModeControl" multiple>
                @for (option of domainsFilterModeList; track option) {
                  <mat-option [value]="option" (click)="getParams()">{{ formOptionsLists.domainsToString.get(option) }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>

      </div>

      <app-table [displayedColumns]="displayedColumns"
                 [isAuthorized]="isAuthorized"
                 [searchTrigger]="searchTrigger"
                 [selectedCategory]="categoryControl"
                 [selectable]="selectMode" [service]="textTypeService">
      </app-table>
    </div>
  </div>
</div>
